import React from "react";
import "./footer.css";

const Footer = () => (
  <>
    <footer className="footer">
      <div className="container">
        <div className="row my-3">
          <div className="col-sm-12 col-md">
            <h1 className="title">Kapcsolat</h1>
            <address>
              <ul className="list-unstyled remove-margin">
                <li>
                  E-mail:{" "}
                  <a
                    className="link"
                    href="mailto:info@szelencecafe.hu?Subject=Info"
                  >
                    info@szelencecafe.hu
                  </a>
                </li>
                <li>
                  Telefon:{" "}
                  <a className="link" href="tel:+36308759079">
                    +36 30 875 90 79
                  </a>
                </li>
              </ul>
            </address>
            <div className="m-1 d-inline-block">
              <a
                href="https://www.instagram.com/szelencecafe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="32"
                  width="32"
                  src="https://cdn.jsdelivr.net/npm/simple-icons@v4/icons/instagram.svg"
                  alt="Instagram"
                  className="img-fluid social-icon"
                />
              </a>
              <a
                href="https://www.facebook.com/szelencecafe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="32"
                  width="32"
                  src="https://cdn.jsdelivr.net/npm/simple-icons@v4/icons/facebook.svg"
                  alt="Facebook"
                  className="img-fluid social-icon"
                />
              </a>
            </div>
          </div>
          <div className="col-sm-12 col-md">
            <h1 className="title">Cím</h1>
            <address>
              <ul className="list-unstyled remove-margin">
                <li>Pauler utca 8.</li>
                <li>Budapest, 1013</li>
              </ul>
            </address>
          </div>
          <div className="col-sm-12 col-md">
            <h1 className="title">Nyitvatartás</h1>
            <ul className="list-unstyled remove-margin">
              <li>Hétfő - Péntek: 11:00 - 16:00</li>
              <li>Szombat: 09:00-16:00</li>
              <li>Vasárnap: zárva</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </>
);

export default Footer;
